import * as styles from "bundle-text:./company.scss";
import templateHTML from "bundle-text:./template.html";
import { getRequiredComponentElements } from "../../../scripts/utils/utility";

export class CompanyComponent extends HTMLElement {
  private ComponentElements: Map<string, HTMLElement>;
  private ComponentNames = {
    valtech: ".one",
    creshya: ".two",
    vdesc: ".vdesc",
    cdesc: ".cdesc",
  };

  private template = () => `
   <style>${styles}</style>
   ${templateHTML}
  `;
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();
    this.ComponentElements = getRequiredComponentElements(
      this,
      this.ComponentNames
    );
    this.initializeAnimationObservers();
  }

  private initializeAnimationObservers() {
    [this.ComponentNames.valtech, this.ComponentNames.creshya].forEach(
      (item) => {
        const el = this.ComponentElements.get(item);
        if (!el) return;
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              el.classList.remove("animation_space"); // Reset in case
              // Force reflow to restart animation
              void el.offsetWidth;
              el.classList.add("animation_space");
            } else {
              el.classList.remove("animation_space");
            }
          },
          { threshold: 0.1 }
        );
        observer.observe(el);
      }
    );

    [this.ComponentNames.vdesc, this.ComponentNames.cdesc].forEach((item) => {
      const el = this.ComponentElements.get(item);
      if (!el) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.remove("animation_blur"); // Reset in case
            // Force reflow to restart animation
            void el.offsetWidth;
            el.classList.add("animation_blur");
          } else {
            el.classList.remove("animation_blur");
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(el);
    });
  }

  connectedCallback() {}

  render() {
    if (this.shadowRoot) {
      this.shadowRoot.innerHTML = this.template().trim();
    }
  }
}

customElements.define("company-component", CompanyComponent);
